import { notification } from 'antd';
import { useParams } from 'react-router-dom';
import { useIntegrateMutation } from '@/types/generated/graphql';

export const useIntegrateIntegration = (integrationId?: number) => {
  const { id } = useParams();
  const [integrate, { loading }] = useIntegrateMutation({
    variables: {
      integrationId: integrationId ?? Number(id),
    },
    onError: (error) => {
      notification.error({ message: error?.message });
    },
  });

  return { integrate, integrating: loading };
};
